import { render, staticRenderFns } from "./CarrierServiceRateDropdown.vue?vue&type=template&id=2e04e981&scoped=true&"
import script from "./CarrierServiceRateDropdown.vue?vue&type=script&lang=js&"
export * from "./CarrierServiceRateDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CarrierServiceRateDropdown.vue?vue&type=style&index=0&id=2e04e981&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04e981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e04e981')) {
      api.createRecord('2e04e981', component.options)
    } else {
      api.reload('2e04e981', component.options)
    }
    module.hot.accept("./CarrierServiceRateDropdown.vue?vue&type=template&id=2e04e981&scoped=true&", function () {
      api.rerender('2e04e981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/CarrierServiceRateDropdown.vue"
export default component.exports